module.exports = __webpack_public_path__ + "static/media/custom-software-development-icon.11184389.svg";